import React from 'react';
import WeeklyInputForm from './WeeklyInputForm';
import KPICards from './KPICards';
import WeeklySessionsChart from './WeeklySessionsChart';
import ClientConversionTable from './ClientConversionTable';
import ReferralSourceBar from './ReferralSourceBar';
import VersionFooter from './VersionFooter';
import LogoutButton from './LogoutButton';

const AdminDashboard = ({ user }) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-bold">📊 Admin Dashboard</h1>
        <LogoutButton />
      </div>
      <KPICards user={user} />
      <WeeklyInputForm user={user} />
      <WeeklySessionsChart user={user} />
      <ClientConversionTable user={user} />
      <ReferralSourceBar user={user} />
      <VersionFooter />
    </div>
  );
};

export default AdminDashboard;
